import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from '../../constants'

export const styles = makeStyles(() => ({
  highlight: {
    backgroundColor: COLORS.lightTeal,
    color: 'inherit',
    padding: 0,
  },
}))
